<template>
  <!-- 分页组件 -->
  <div class="pageNav">
    <div style="font-size: 15px">
      共{{ total }}条 分{{ Math.ceil(total / pageSize) }}页
    </div>
    <el-pagination
      style="background: #eee; flex: 1"
      @current-change="goPage"
      :current-page.sync="pageNum"
      :page-size="pageSize"
      layout=" prev, pager, next"
      :total="total"
    ></el-pagination>
    <div style="padding: 5px">
      <el-input-number
        v-model="pageNum"
        size="mini"
        :controls="false"
        style="width: 50px"
      ></el-input-number>
      <el-button
        type="primary"
        style="background: #719468; border-radius: 0; border: 0"
        size="mini"
        @click="goPage"
        >GO</el-button
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "pageNav",
  props: {
    total: {
      type: Number,
      default: 0,
    },
    pageSize: {
      type: Number,
      default: 10,
    },
    pageNum: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      value: 1,
    };
  },
  methods: {
    goPage() {
      this.$emit("update:pageNum", this.pageNum);
      this.$emit("goPage");
    },
  },
};
</script>

<style lang="scss">
.pageNav {
  background: #eeeeee;
  display: flex;
  padding: 0 21px;
  align-items: center;
  .el-pager li.active {
    color: #719468;
  }
  .el-pager li:hover {
    color: #719468;
  }
  
  .el-pagination .btn-next,
  .el-pagination .btn-prev {
    background: #eee;
  }
  .el-pager li {
    background: #eee;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/pager/index.vue